export const BRAND_NAME = 'CricKhelo';
// Note: It is the main site url. Ex - CricKhelo.com, etc.
export const BRAND_DOMAIN = 'crickhelo.com';
// Note: It is the main site url. Ex - playnetgaming.net, etc.
export const BRAND_DOMAIN_SKIN_URL = 'crickhelo.com';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'cue88.com';